export default {
  iframe: {
    origin: {
      test: 'https://www-test.tinkoff.ru/',
      prod: 'https://www.tbank.ru/',
    },
    path: 'cards/debit-cards/black/iframe/form/invest24/',
  },
  secretCode: {
    key: 'secret',
    code: '32vb88oked',
  },
} as const;
